/* FINISH SOFTSKILLS USER COURSE */
export const FINISH_SOFTSKILLS_USER_COURSE = "FINISH_SOFTSKILLS_USER_COURSE"
export const FINISH_SOFTSKILLS_USER_COURSE_SUCCESS =
  "FINISH_SOFTSKILLS_USER_COURSE_SUCCESS"
export const FINISH_SOFTSKILLS_USER_COURSE_CLEAN =
  "FINISH_SOFTSKILLS_USER_COURSE_CLEAN"
export const FINISH_SOFTSKILLS_USER_COURSE_ERROR =
  "START_SOFTSKILLS_USER_COURSE_ERROR"
